import React, { useState } from "react";
import { Link } from "react-router-dom";
import ImagePreviewModal from "../imageView/ImagePreviewModal";

const CustomerDocument = ({ customerData }) => {
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const handleImageClick = (imgUrl: string) => {
    setSelectedImage(imgUrl);
    setShowImageModal(true);
  };
  return (
    <div className="modal fade" id="documents_details">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h3>Customer Details</h3>
            <div className="d-flex align-items-center"></div>
            <button
              type="button"
              className="btn-close custom-btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ti ti-x" />
            </button>
          </div>
          {customerData && (
            <div className="card-body p-3  back-ground">
              <h5 className="mb-3">Documents</h5>
              <div className="list-group ">
                <div className="d-flex row flex-wrap justify-content-between">
                  {Object.entries(customerData?.allData)
                    .filter(
                      ([, value]) =>
                        typeof value === "string" && value.startsWith("http")
                    )
                    .map(([key, value], index) => {
                      const title = key
                        .replace(/([A-Z])/g, " $1")
                        .replace("Url", "")
                        .trim()
                        .replace(/^\w/, (c) => c.toUpperCase());
                      return (
                        <div key={index} className="document_image col-6">
                          <h6 className="fw-bold mb-2">
                            {title === "Aadharbackimageurl"
                              ? "Aadhar Back Image"
                              : title === "Guarantorimageurl"
                              ? "Guarantor Image"
                              : title === "Lockscreenimageurl"
                              ? "Lock Screen Image"
                              : title}
                          </h6>{" "}
                          <p
                            className="info"
                            style={{ width: 120, height: 140 }}
                          >
                            <img
                              src={value as string}
                              alt={key.replace("Url", "")}
                              style={{
                                width: "200px",
                                objectFit: "contain",
                                cursor: "pointer",
                              }}
                              onClick={() => handleImageClick(value as string)}
                            />
                          </p>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <ImagePreviewModal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        imageUrl={selectedImage}
      />
    </div>
  );
};
export default CustomerDocument;
